export var sliceContent = function sliceContent(content, maxChars) {
  return maxChars && content.length > maxChars ? "".concat(content.slice(0, maxChars), "...") : content;
};